import { createCacheStore } from '@lib/utils/cache';
import { OrganizationService } from '@api/OrganizationService';

/** Cached OrganizationService.getOrganizations() reads. */
export const organizationsCache = createCacheStore(
    'organization/organizations',
    OrganizationService.getOrganizations,
);

/** Cached OrganizationService.getOrgLicense(orgId) reads. */
export const orgLicenseCache = createCacheStore(
    'organization/orgLicense',
    OrganizationService.getOrgLicense,
);

/** Drops all cached organization data (after organization mutations). */
export const invalidateOrganizations = (): void => {
    organizationsCache.invalidateAll();
};
